import axios, { AxiosInstance } from 'axios';
import getHostUrl from './getHostUrl';

function getHostRequest(hostName: string, nodeName: string, isHongKong: boolean): AxiosInstance {
  const hostRequest: AxiosInstance = axios.create({
    baseURL: getHostUrl(hostName, nodeName, isHongKong),
  });

  hostRequest.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 500) {
      console.error(error.response.data);
    }
    return Promise.reject(error);
  });

  return hostRequest;
}

export default getHostRequest;
